import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import styles from './studio-list.css.mjs';

export class StudioList extends LitElement {
  static styles = styles;

  static properties = {
    /**
     * items: Array of objects like { tag: 'studio-button', props: { size: 'large', icon: 'vector-squares', 'icon-only': true } }
     */
    items: { type: Array }
  };

  constructor() {
    super();
    this.items = [];
  }

  render() {
    return html`
      <ul class="list">
        ${this.items.map((item, index) => {
          const tag = item.tag || 'div';
          const props = item.props || {};

          // 1) Extract "slot" as inner text, defaulting to empty
          const { slot: innerText = '', ...restProps } = props;

          // 2) Build hyphenated attribute string
          const attrs = Object.entries(restProps)
            .map(([key, value]) => {
              // turn camelCase keys into kebab-case attrs
              const attrName = key.replace(/([A-Z])/g, '-$1').toLowerCase();
              // boolean true => presence, false => omit
              if (typeof value === 'boolean') {
                return value ? attrName : '';
              }
              // string or number => key="value"
              return `${attrName}="${value}"`;
            })
            .filter(Boolean)
            .join(' ');

          // 3) compute rounding classes
          const classes = ['list-item']
            .concat(index === 0 ? 'first' : [])
            .concat(index === this.items.length - 1 ? 'last' : [])
            .join(' ');

          // 4) render dynamic tag with innerText
          //    unsafeHTML needed so that <studio-button> is interpreted
          return unsafeHTML(`
            <li class="${classes}" role="listitem">
              <slot name="item-body">
                <${tag} ${attrs}>${innerText}</${tag}>
              </slot>
            </li>
            <slot></slot>
          `);
        })}
      </ul>
    `;
  }}

customElements.define('studio-list', StudioList);

